import React from "react";
import { CSV_SCHEMA, productFields } from "./schema";

interface Props {
  rawHeaders: string[];
  columnMap: Record<string, string>;
  onColumnMapChange: (field: string, csvColumn: string) => void;
  onContinue: () => void;
}

const StepColumnMapping: React.FC<Props> = ({
  rawHeaders,
  columnMap,
  onColumnMapChange,
  onContinue,
}) => (
  <div>
    <h3 className="font-semibold mb-3 text-left">
      Map your file's columns to each product field
    </h3>
    <p className="text-xs text-gray-500 mb-4">
      Fields marked <span className="text-red-600 font-medium">*</span> are required.
    </p>

    {Object.entries(productFields).map(([field, label]) => {
      const isRequired = CSV_SCHEMA.find((c) => c.field === field)?.required;
      return (
        <div key={field} className="mb-4 text-left">
          <label className="form-label">
            {label}
            {isRequired && <span className="text-red-500 ml-1">*</span>}
          </label>
          <select
            className="border p-2 rounded-md form-input w-full"
            value={columnMap[field] ?? ""}
            onChange={(e) => onColumnMapChange(field, e.target.value)}
          >
            <option value="">Select column</option>
            {rawHeaders.map((header) => (
              <option key={header} value={header}>{header}</option>
            ))}
          </select>
        </div>
      );
    })}

    <div className="flex justify-end">
      <button
        onClick={onContinue}
        className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md"
      >
        Continue
      </button>
    </div>
  </div>
);

export default StepColumnMapping;
